




import { Component, Vue } from 'vue-property-decorator';
import LeafletsModlue from '@/store/modules/leaflets';

@Component
export default class Print extends Vue {
  /**
   * 印刷を実行
   */
  private print() {
    LeafletsModlue.print();
  }
}
